module.exports = __webpack_public_path__ + "img/1.63da9fe0.png";